import React from 'react';

import { ActionsMenu } from './ActionsMenu';
import { ChatbotIcon } from '../icons/ChatbotIcon';

import styles from './AiChatbot.module.scss';

export function WidgetHeader() {
  return (
    <div className={styles.headerContainer}>
      <div className={styles.headerArea}>
        <div className={styles.chatbotIconContainer}>
          <ChatbotIcon />
        </div>
        Ask Cymbot
      </div>
      <div className={styles.headerArea}>
        <ActionsMenu />
      </div>
    </div>
  );
}
